import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardContent,
  Container,
  InputAdornment,
  SvgIcon,
  TextField,
} from '@material-ui/core';
import CustomerListResults from 'src/components/customer/CustomerListResults';
import { useQuery } from '@apollo/client';
import { UserQueries } from '../models/user';
import { Search as SearchIcon } from 'react-feather';
import { useState } from 'react';

const CustomerList = () => {
  const { data: { users = [] } = {}, loading } = useQuery(UserQueries.fetchUsers);
  const [searchValue, setSearchValue] = useState('');

  const newUsers = users.filter((user) =>
    user?.fullName.toLowerCase().includes(searchValue.toLowerCase())
  );

  const searchUsers = (val) => {
    setSearchValue(val.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Users | Vithoulkas App Admin</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box>
            <Box sx={{ mt: 3 }}>
              <Card>
                <CardContent>
                  <Box sx={{ maxWidth: 500 }}>
                    <TextField
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SvgIcon fontSize="small" color="action">
                              <SearchIcon />
                            </SvgIcon>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Search customer"
                      variant="outlined"
                      onChange={searchUsers}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>
          <Box sx={{ pt: 3 }}>
            <CustomerListResults customers={newUsers} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CustomerList;
